import config from '../config';
// Configure Descope client with proper storage
export const configureDescopeClient = () => {
    // The AuthProvider should handle this automatically with persistTokens={true}
    // But we can add additional configuration here if needed
    console.log('🔐 Configuring Descope client with project ID:', config.descopeProjectId);
    return {
        projectId: config.descopeProjectId,
        persistTokens: true,
    };
};
// Export the configuration for use in AuthProvider
export const descopeConfig = configureDescopeClient();
